import React from 'react';
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import './Sparkline.scss';

const Sparkline = ({ data = [], color = '#FF3232', height = 40 ,width="50%"}) => {
    if (!data || data.length === 0) {
        return null;
    }

    // Normalize data to ensure it's in the right format
    const normalizedData = data.map((item, index) => {
        if (typeof item === 'number') {
            return { value: item, index };
        }
        if (typeof item === 'object' && item !== null) {
            return { value: item.value || item, index };
        }
        return { value: Number(item) || 0, index };
    }).filter(item => !isNaN(item.value));

    if (normalizedData.length === 0) {
        return null;
    }

    // Calculate min and max for proper scaling
    const values = normalizedData.map(d => d.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1; // Avoid division by zero

    // Add padding to min/max for better visualization
    const padding = range * 0.1;
    const domainMin = min - padding;
    const domainMax = max + padding;

    return (
        <div className="sparkline-container" style={{ height: `${height}px` }}>
            <ResponsiveContainer width={width} height={height}>
                <LineChart 
                    data={normalizedData} 
                    margin={{ top: 2, right: 2, left: 2, bottom: 2 }}
                >
                    <XAxis 
                        dataKey="index" 
                        hide={true}
                    />
                    <YAxis 
                        domain={[domainMin, domainMax]} 
                        hide={true}
                    />
                    <Line
                        type="monotone"
                        dataKey="value"
                        stroke={color}
                        strokeWidth={2}
                        dot={false}
                        activeDot={false}
                        isAnimationActive={true}
                        animationDuration={800}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default Sparkline;

